import * as React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Layout } from "../components/Layout";
import { Header } from "../components/guide/Header";
import { Footer2 } from "../components/guide/Footer";
import { About2 } from "../components/guide/About";
import { Benefits2 } from "../components/guide/Benefits";
import { HowToStart2 } from "../components/guide/HowToStart";
import { SafeKids } from "../components/SafeKids/SafeKids";

import { HowToUse } from "../components/guide/Stream/2/HowToUse";
import { WhatsDo } from "../components/guide/Stream/2/WhatsDo";
import { HowToBePopular } from "../components/guide/Stream/2/HowToBePopular";
import { StopContent } from "../components/guide/Stream/2/StopContent";

import { ReadMore } from "../components/ReadMore";

const Guide = styled("main")(
  css({
    background: "linear-gradient(90deg, #7CFD34 0%, #1BC6AF 100%)",
    position: "relative",
    zIndex: 0,
    overflow: "hidden",
  })
);

const GuidePage = () => (
  <Layout>
    <Guide>
      <Header
        no={2}
        title="Гайд №2"
        subtitle="Как залипнуть вместе на tiktok"
      />
      <About2 />
      <Benefits2 />

      <HowToStart2 />
      <HowToUse />
      <WhatsDo />
      <HowToBePopular />
      <StopContent />

      <Footer2 />
      <ReadMore without={2} />
      <SafeKids />
    </Guide>
  </Layout>
);

export default GuidePage;
